<template>
  <base-modal title="Upload Asset Type Image">
    <image-manager ref="assetTypeImageManager" @upload="uploadImage"/>
  </base-modal>
</template>

<script>
import {mapState} from "vuex";
export default {
  data: () => ({
    uploading: false,
  }),

  computed:{
    ...mapState('assetType', ['assetType'])
  },

  methods: {
    uploadImage(blob) {
    this.uploading = true
      const payload = {
        assetTypeId: this.$route.params.assetType,
        image: blob
      }
      this.$store.dispatch('assetType/uploadImage', payload).then(() => {
        this.uploading = false
        this.$refs.assetTypeImageManager.completed()
        this.$toast.success('Image uploaded')
        this.$close(false)
      }).catch(() => {
        this.uploading = false
        this.$close(false)
        this.$toast.error('whoops something went wrong, please try again.')
      })
    },
  }
}
</script>